import React from "react";
import { Modal, ModalHeader, ModalBody, Button, Row, Col } from "reactstrap";
import ExportPDFTemplate from "./ExportPDFTemplate"; // assure-toi que le chemin est correct
import logo from "../../../assets/images/logo-cinzan-edu.png";

import { PDFDownloadLink } from "@react-pdf/renderer";
import FichePDFDocument from "./ExportPDFTemplate";

const FichePreviewModal = ({ isOpen, toggle, record }) => {
  if (!record) return null;

  // 🔹 Fonction pour générer le PDF
  const handleDownloadPDF = () => {
    exportPDFTemplate(record); // envoie le record au PDF template
  };

  // Informations à afficher dans le modal
  const infoFields = [
    { label: "N°", value: record.id },
    { label: "Réf. Évaluation", value: record.evaluation?.title || "-" },
    { label: "EC", value: record.course_component?.code || "-" },
    { label: "Matricule", value: record.student?.student_number || "-" },
    { label: "Nom et Prénom", value: `${record.student?.first_name || ""} ${record.student?.last_name || ""}` },
    { label: "Année Académique", value: record.academic_year?.name || "-" },
    { label: "Semestre", value: record.semester?.code || "-" },
    { label: "Niveau", value: record.study_level?.name || "-" },
  ];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <div className="d-flex align-items-center">
          {/* Logo à gauche */}
          <img src={logo} alt="Logo" style={{ width: 60, height: "auto", marginRight: 15 }} />
          {/* Titre à droite */}
          <div>
            <h5 className="mb-0">Faculté Cinzan Edu</h5>
            <small>Téléphone: +223 XXX XXX | Email: contact@cinzan.edu | Adresse: BP XXX</small>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <Row className="mb-3">
          {infoFields.map((field, index) => (
            <Col md={4} key={index} className="mb-2">
              <strong>{field.label}:</strong> {field.value}
            </Col>
          ))}
        </Row>

        {/* Bouton Télécharger PDF */}
        {/*<Button color="success" onClick={handleDownloadPDF}>
          Télécharger PDF
        </Button>*/}

        <PDFDownloadLink
            document={<FichePDFDocument record={record} />}
            fileName={`Fiche_${record.student?.student_number || record.id}.pdf`}
            >
            {({ loading }) =>
                loading ? (
                <Button color="secondary">Génération...</Button>
                ) : (
                <Button color="success">Télécharger PDF</Button>
                )
            }
            </PDFDownloadLink>


      </ModalBody>
    </Modal>
  );
};

export default FichePreviewModal;
